import type { IPrizePopCampaign, CampaignSource } from '../../types/campaign.types';
import { PRIZE_POP_CAMPAIGN_TYPE, PRIZE_POP_STATUS_ORDER } from '../../types/campaign.types';
import { evaluateCampaignIntervals } from '../../hooks/data/campaignStatus/variants/prizePop/evaluatePrizePopCampaignStatus';
import { LEVEL_ORDER } from '../campaignHelpers';

export const isPrizePopSource = (source: CampaignSource): source is IPrizePopCampaign => {
  return 'type' in source && source.type === PRIZE_POP_CAMPAIGN_TYPE;
};

export const sortPrizePopCampaigns = (campaigns: IPrizePopCampaign[]): IPrizePopCampaign[] => {
  const ret = [...campaigns].sort((a, b) => {
    // 0. Campaigns with all intervals ended go last (treated as finished)
    const aEnded = evaluateCampaignIntervals(a).allIntervalsEnded;
    const bEnded = evaluateCampaignIntervals(b).allIntervalsEnded;
    if (aEnded !== bEnded) return aEnded ? 1 : -1;

    // 1. Status: Active > Promo > Completed
    const statusDiff = PRIZE_POP_STATUS_ORDER[a.status] - PRIZE_POP_STATUS_ORDER[b.status];
    if (statusDiff !== 0) return statusDiff;

    // 2. Joined first
    if (a.joined !== b.joined) return a.joined ? -1 : 1;

    // 3. Priority (level): Gold > Purple > Red > Blue > Green > Madness
    const levelDiff = LEVEL_ORDER[a.level] - LEVEL_ORDER[b.level];
    if (levelDiff !== 0) return levelDiff;

    // 4. End time ascending (closest end time first)
    return new Date(a.endDate).getTime() - new Date(b.endDate).getTime();
  });

  return ret;
};
